<template>
  <div class="model-content">
    <div
      class="model_71"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <img class="img-box" :src="url" />

      <div class="merchant-name">
        <div class="merchant-name-title">{{ posterList.merchant_name }}</div>
      </div>
      <div class="food_name">
        <div class="food_name_text">{{ posterList.food_name }}</div>
      </div>

      <div class="food_img">
        <img :src="posterList.food_img" alt="" />
      </div>

      <div class="food_price" :style="{ fontSize: posterList.fontSize + 'px' }">
        {{ posterList.food_price }}
      </div>

      <div class="old_price">
        <div class="old_price_text" v-if="posterList.lang == 'ug'">
          ئەسلى باھاسى :
        </div>
        <div v-if="posterList.lang == 'zh'">原价 :</div>
        <div class="line" :class="posterList.lang == 'zh' ? 'color-white' : ''">
          <span class="number-price"> {{ posterList.old_price }} </span>
          <span v-if="posterList.lang == 'ug'"> يۈەن </span>
          <span v-if="posterList.lang == 'zh'"> 元 </span>
        </div>
      </div>

      <div class="merchant_qrcode">
        <img :src="posterList.merchant_qrcode" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_71",
  data() {
    return {
      posterList: {},
      url: require("../../img/poster/model_71.png"),
    };
  },
  created() {
    this.canvasfortitle(
      this.$route.query.merchant_name,
      this.$route.query.food_name,
      this.$route.query
    );
  },
  methods: {
    /**
     * 处理标题和食物名称以生成海报的canvas数据
     *
     * @param merchant_name 商家名称
     * @param food_names 食物名称
     * @param query 查询参数，包括食物价格等
     */
    canvasfortitle(merchant_name = "", food_names = "", query = {}) {
      const MAX_MERCHANT_LENGTH = 40;
      const MAX_FOOD_LENGTH = 36;
      const replaceParentheses = (str = "") => {
        return String(str).replace(/[()（）]/g, (match) =>
          match === "(" || match === "（" ? "-" : " "
        );
      };
      const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length <= maxLength
          ? text
          : `${text.substring(0, maxLength)}...`;
      };
      const res_name = replaceParentheses(merchant_name);
      const food_name = replaceParentheses(food_names);
      this.posterList = {
        ...query,
        merchant_name: truncateText(res_name, MAX_MERCHANT_LENGTH),
        food_name: truncateText(food_name, MAX_FOOD_LENGTH),
        food_price: parseFloat(query.food_price) || 0,
      };
      const priceLength = String(this.posterList.food_price).replace(
        ".",
        ""
      ).length;
      const fontSizeMap = {
        3: 40,
        4: 32,
        5: 28,
        6: 26,
      };
      this.posterList.fontSize = fontSizeMap[priceLength] || 48;
    },
  },
};
</script>

<style scoped>
@import url("../../css/model_65/index.css");
.model-content {
  width: 400px;
  height: 734px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_71 {
  width: 400px;
  height: 734px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant-name {
  position: absolute;
  top: 124px;
  right: 50%;
  transform: translateX(49%);
  color: #272726;
  width: 300px;
  height: 56px;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.merchant-name-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}
.model_ug .merchant-name-title {
  font-family: "Nurjanbay Kufi Chong" !important;
  font-size: 20px;
}
.model_zh .merchant-name-title {
  font-family: "FZCQK--GBK1-0" !important;
  font-size: 26px;
}
.food_name {
  position: absolute;
  width: 140px;
  height: 50px;
  top: 252px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  text-align: center;
  transform: rotate(-33deg);
}

.food_name_text {
  color: #272726;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}

.model_ug .food_name_text {
  font-family: "Nurjanbay Kufi Chong" !important;
  font-size: 22px;
  line-height: 24px;
  font-variant: unicase;
}
.model_zh .food_name_text {
  font-family: "FZCQK--GBK1-0" !important;
  font-size: 24px;
}

.food_img {
  position: absolute;
  top: 323px;
  left: 32px;
  width: 348px;
  height: 216px;
  overflow: hidden;
  transform: rotate(-1deg);
}

.food_img img {
  width: 100%;
  height: 100%;
  clip-path: ellipse(50% 50% at 50% 50%);
  object-fit: cover;
}

.food_price {
  position: absolute;
  top: 268px;
  left: 34px;
  width: 80px;
  text-align: center;
  font-weight: bold;
  color: #93be3d;
  font-family: "UzluqEgme" !important;
}
.old_price {
  position: absolute;
  bottom: 156px;
  font-size: 14px;
  color: #d3d2d1;
  display: flex;
  align-items: center;
  right: 50px;
}

.old_price .line {
  text-decoration: line-through;
  padding-inline: 4px;
}

.merchant_qrcode {
  position: absolute;
  bottom: 15px;
  right: 69px;
  width: 100px;
  height: 100px;
  box-sizing: border-box;
}

.merchant_qrcode img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.number-price {
  font-family: "UzluqEgme" !important;
}
</style>
